import React from "react";

import { Home2026ProofBlock as Value } from "@reactivated";

import { SectionHeader } from "../../shared/SectionHeader";
import { ProofHalo } from "./ProofHalo";
import { StatRow } from "./Stat";

import styles from "./index.module.scss";

const PER_ROW = 2;

/**
 * The 2026 homepage's Proof section: a header and four counting stats over a
 * green field.
 */
export const Home2026ProofBlock = (props: Value) => {
    const sectionRef = React.useRef<HTMLElement>(null);
    const stats = props.stats ?? [];
    const rows = Array.from(
        { length: Math.ceil(stats.length / PER_ROW) },
        (_, r) => stats.slice(r * PER_ROW, (r + 1) * PER_ROW),
    );
    return (
        <section ref={sectionRef} className={styles.proof}>
            <ProofHalo hostRef={sectionRef} className={styles.halo} />
            <div className={styles.inner}>
                {props.header && (
                    <SectionHeader
                        value={props.header}
                        align="left"
                        sequence={{ title: 0, body: 180, cta: 280 }}
                        enter={0.8}
                        exit={0.94}
                        className={styles.header}
                    />
                )}
                {stats.length > 0 && (
                    <ul className={styles.stats}>
                        {rows.map((row, r) => (
                            <StatRow key={row[0].id} row={r} stats={row} />
                        ))}
                    </ul>
                )}
            </div>
        </section>
    );
};
